import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { Actions, ofType } from '@ngrx/effects';

import { IAuroraState } from '@apps/aurora.state';
import { getQuickSearchValue } from '@apps/root/store';
import { RootQuickSearchValueChanged } from '@apps/root/store/quick-search/quick-search.actions';
import * as fromRootStore from '@apps/root/store';

@Component({
    selector: 'aa-quick-search-word',
    templateUrl: './quick-search-word.component.html',
    styleUrls: [
        './quick-search-word.component.scss'
    ],
    standalone: false
})
export class QuickSearchWordComponent implements OnInit, OnDestroy
{
    @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
    @Input() storageKey: string = null;
    @Output() qsWordChanged: EventEmitter<string> = new EventEmitter<string>();
    public searchGroup: UntypedFormGroup;
    public empty: boolean = true;
    public static QsWordField: string = 'qsWord';
    private destroyator = new Subject();
    private key: string;
    private qsWord: string;

    constructor (
        private formBuilder: UntypedFormBuilder,
        private store: Store<IAuroraState>,
        private actions: Actions,
        private routerStore: Store<any>
    )
    {
        this.searchGroup = this.formBuilder.group({
            qsWord: ['']
        });
    }

    ngOnInit ()
    {
        this.routerStore
            .pipe(
                take(1),
                select(fromRootStore.getRouteInfos),
                map((obj: any): string =>
                    obj.url
                ),
                switchMap((url: string) =>
                {
                    this.key = this.storageKey || url;

                    return this.store.pipe(
                        select(getQuickSearchValue, { key: this.key }),
                        take(1),
                        tap((qsWord: string) =>
                        {
                            this.empty = this.qsWord === '';
                            this.searchGroup.get(QuickSearchWordComponent.QsWordField).setValue(qsWord);
                        })
                    );
                })
            )
            .subscribe();
        this.searchGroup.get(QuickSearchWordComponent.QsWordField).valueChanges
            .pipe(
                debounceTime(250),
                distinctUntilChanged(),
                tap((qsWord: string) =>
                    this.processQsWord(qsWord)
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();

        this.actions
            .pipe(
                ofType(fromRootStore.RootSearchStoreActions.RootSearchEnterKey),
                tap(({ searchValue } : { searchValue: string }) =>
                {
                    this.searchGroup.get(QuickSearchWordComponent.QsWordField).setValue(searchValue);
                    this.processQsWord(searchValue);
                }
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();

        this.actions
            .pipe(
                ofType(fromRootStore.RootSearchStoreActions.RootSearchResultsCleared),
                tap(() =>
                    this.resetSearch()
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    resetSearch ()
    {
        this.searchGroup.get(QuickSearchWordComponent.QsWordField).setValue('');
        this.qsWordChanged.emit('');
    }

    private processQsWord (qsWord: string)
    {
        this.qsWord = qsWord;
        this.qsWordChanged.emit(this.qsWord);
        this.empty = this.qsWord === '';
        this.store.dispatch(RootQuickSearchValueChanged({
            key: this.storageKey || this.key,
            searchValue: this.qsWord
        }));
        // if (this.empty)
        // {
        //     this.searchInput.nativeElement.focus();
        // }
    }
}
